module.exports = __webpack_public_path__ + "img/download.aaf1f3f4.svg";